import { RegionId } from '../region-id.enum';
import { StripeProductType } from '../stripe-product-type';

/**
 * Lightweight list item returned by GET /api/qc-checklist-templates.
 */
export interface QCChecklistTemplateListItem {
    readonly id: number;
    readonly name: string;
    readonly isActive: boolean;
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentSubTypeOriginalId?: number | null;
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: RegionId | null;
    readonly stripeProductType?: StripeProductType | null;
    readonly itemCount: number;
    readonly createdDate: string;
    readonly modifiedDate: string;
    readonly createdBy?: string | null;
    readonly modifiedBy?: string | null;
}
